export const PRIMARY_BLUE = 'rgb(0, 86, 210)';
export const PRIMARY_HOVER_BLUE = 'rgb(0, 68, 168)';
export const BG_LIGHT_BLUE = 'rgb(240, 248, 255)';

// export default {
//     PRIMARY_BLUE,
//     PRIMARY_HOVER_BLUE,
//     BG_LIGHT_BLUE
// }